<template>
    <div class="main">
        <h2>订单查询</h2>
        <v-form style="width: 100%; margin-top: 40px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="订单号">
                <input class="form-control" type="text" v-model="form.id">
            </v-form-item>
            <v-form-item label="联系人手机">
                <input class="form-control" type="text" v-model="form.customerPhone">
            </v-form-item>
        </v-form>
        <v-form style="width: 100%; margin-top: 30px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="订单状态">
                <v-select v-model="orderState" placeholder="请选择">
                    <v-option v-for="item in ORDER_STATE_LIST" :label="item.name" :value="item.value" :key="item.value"></v-option>
                </v-select>
            </v-form-item>
            <v-button type="primary" @click="searchOrder">搜索</v-button>
        </v-form>
        <h2>查询结果<v-button type="primary" @click="exportExcel">导出订单</v-button></h2>
        <v-table style="width: 100%; background-color: #FFF; margin-top: 20px;"
                 :data="tableData"
                 :column="tableColumn"
                 @getOrderDetails="getOrderDetails"
                 v-loading="isLoading"
        >
            <template slot="productInfo" scope="props">
                <div>产品名称：{{ props.data.productName }}</div>
                <div>产品编号：{{ props.data.productNo }}</div>
                <div>货号：{{ props.data.goodsNo }}</div>
            </template>
            <template slot="customerInfo" scope="props">
                <div>{{ props.data.customerName }}</div>
                <div>{{ props.data.customerPhone }}</div>
                <div>{{ props.data.customerAddress }}</div>
            </template>
        </v-table>
        <v-pagination
            :current='currentPage'
            :total='Math.ceil(totalCount / 20)'
            :size="'md'"
            :first="false"
            :last="false"
            v-on:current-change="currentChangeFunc($event)"
            style="text-align: right;"
        ></v-pagination>
    </div>
</template>

<style lang="scss" scoped="scoped">
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
        > h2 {
            font-size: 24px;
            &:nth-of-type(2) {
                margin-top: 60px;
            }
            > .btn {
                float: right;
            }
        }
        .form-horizontal {
            display: flex;
            .v-form-item {
                width: 20%;
                margin-bottom: 0;
                &:nth-child(n+2) {
                    margin-left: 5%;
                }
                .form-control {
                    width: 100%;
                    display: inline-block;
                }
            }
            .btn-primary {
                margin-left: 30px;
                width: 120px;
            }
        }
    }
</style>

<script>
    import Api from 'api/wenchuang'
    import Moment from 'moment'
    import { ORDER_STATE_LIST } from '../constant.js'

    export default {
        data () {
            return {
                form: {
                    id: '',
                    customerPhone: ''
                },
                orderState: -1,  // 全部订单
                ORDER_STATE_LIST: ORDER_STATE_LIST,
                currentPage: 1,
                totalCount: 0,
                tableData: [],
                tableColumn: [
                    {
                        key: 'id',
                        name: '订单号'
                    },
                    {
                        key: 'productInfo',
                        name: '产品名称',
                        type: 'slot',
                        slot: 'productInfo'
                    },
                    {
                        key: 'totalPrice',
                        name: '总价'
                    },
                    {
                        key: 'refundGoodsInfo',
                        name: '商家信息'
                    },
                    {
                        key: 'orderCreateTime',
                        name: '下单时间'
                    },
                    {
                        key: 'customerInfo',
                        name: '联系人信息',
                        type: 'slot',
                        slot: 'customerInfo'
                    },
                    {
                        key: 'extInfo',
                        name: '备注'
                    },
                    {
                        key: 'orderStatusStr',
                        name: '状态'
                    },
                    {
                        key: 'action',
                        name: '操作',
                        type: 'btn',
                        opt: [{
                            text: '查看订单',
                            method: 'getOrderDetails'
                        }]
                    }
                ],
                isLoading: false
            }
        },
        methods: {

            // 获取订单数据
            getTableData () {
                this.isLoading = true;
                Api.getOrderListData(this.orderState, this.form, this.currentPage)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let tableData = [];
                            data.forEach((item) => {
                                tableData.push({
                                    id: item.id,
                                    productInfo: {
                                        productName: item.productName,
                                        productNo: item.productNo,
                                        goodsNo: item.goodsNo
                                    },
                                    totalPrice: item.totalPrice,
                                    refundGoodsInfo: item.refundGoodsInfo,
                                    orderCreateTime: Moment(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                    customerInfo: {
                                        customerName: item.customerName,
                                        customerPhone: item.customerPhone,
                                        customerAddress: item.customerAddress
                                    },
                                    extInfo: item.extInfo,
                                    orderStatusStr: item.orderStatusStr
                                })
                            })
                            this.tableData = tableData;
                            this.totalCount = res.paging.count;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 查看订单
            getOrderDetails (row, col, val, data) {
                console.log(row, col, val, data);
                if (data.id) {
                    router.push({name: 'wenchuangOrderDetails', params: {orderId: data.id}});
                }
            },

            // 搜索订单
            searchOrder () {
                this.getTableData();
            },

            // 导出订单
            exportExcel () {
                let params = {
                    orderState: this.orderState,
                    id: this.form.id,
                    customerPhone: this.form.customerPhone
                }
                Api.downloadOrder(params);
            },

            // 切换页码
            currentChangeFunc (ev) {
                this.currentPage = ev.current;
                this.getTableData();
            }
        },
        created () {
            this.getTableData();
        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?8a42ffa8